// Guilty Soda theme script: pack pricing, Shopify AJAX cart in the slide-in drawer,
// menu, background videos, can-crack sound and nutrition tabs.
// Config comes from window.GuiltyTheme, written by layout/theme.liquid.
(function () {
  var cfg = window.GuiltyTheme || {};
  var routes = cfg.routes || {};
  var root = (routes.root || "/").replace(/\/?$/, "/");
  var urls = {
    add: (routes.cartAdd || root + "cart/add") + ".js",
    change: (routes.cartChange || root + "cart/change") + ".js",
    cart: (routes.cart || root + "cart") + ".js",
    checkout: routes.checkout || "/checkout"
  };
  var strings = cfg.strings || {};
  var $$ = function (sel, rootEl) { return Array.prototype.slice.call((rootEl || document).querySelectorAll(sel)); };
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };

  // Money in the shop's own format, e.g. "${{amount}}"
  function group(cents, decimals, thousands, decimal) {
    var n = (cents / 100).toFixed(decimals);
    var parts = n.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
  }
  function money(cents) {
    cents = Math.round(+cents || 0);
    var fmt = cfg.moneyFormat || "${{amount}}";
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case "amount_no_decimals": return group(cents, 0, ",", ".");
        case "amount_with_comma_separator": return group(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return group(cents, 0, ".", ",");
        case "amount_with_apostrophe_separator": return group(cents, 2, "'", ".");
        case "amount_with_space_separator": return group(cents, 2, " ", ",");
        default: return group(cents, 2, ",", ".");
      }
    });
  }

  function request(url, body) {
    return fetch(url, {
      method: body ? "POST" : "GET",
      credentials: "same-origin",
      headers: body ? { "Content-Type": "application/json", Accept: "application/json" } : { Accept: "application/json" },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var err = new Error(data.description || data.message || "Cart error"); err.data = data; throw err; }
        return data;
      });
    });
  }

  // Pack size updates the displayed price; Add to cart posts to /cart/add.js
  $$("[data-product-card]").forEach(function (card) {
    var out = card.querySelector("[data-price-out]");
    var perCan = card.querySelector("[data-per-can-out]");
    var buy = card.querySelector("[data-cans]");
    var cans = buy ? +buy.getAttribute("data-cans") : 0;
    $$('input[type="radio"]', card).forEach(function (r) {
      r.addEventListener("change", function () {
        var price = +r.getAttribute("data-price");
        if (out) out.textContent = money(price);
        if (perCan && cans) perCan.textContent = money(Math.floor(price / cans));
      });
    });
    var add = card.querySelector("[data-add]");
    if (!add) return;
    var label = add.textContent;
    add.addEventListener("click", function () {
      var picked = card.querySelector('input[type="radio"]:checked');
      if (!picked || add.disabled) return;
      add.disabled = true;
      request(urls.add, { items: [{ id: +picked.value, quantity: 1 }] })
        .then(function () { return refresh(); })
        .then(function () {
          add.textContent = strings.added || "Added"; add.classList.add("added");
        })
        .catch(function (e) {
          add.textContent = strings.unavailable || "Not available";
          if (window.console) console.warn(e);
        })
        .then(function () {
          setTimeout(function () { add.textContent = label; add.classList.remove("added"); add.disabled = false; }, 1400);
        });
    });
  });

  // Cart drawer
  var drawer = document.querySelector("[data-drawer]");
  var scrim = document.querySelector(".drawer-scrim");
  var list = document.querySelector("[data-cart-items]");
  function open(v) { if (drawer) { drawer.hidden = !v; scrim.hidden = !v; } }
  $$("[data-open-cart]").forEach(function (b) { b.addEventListener("click", function () { open(true); refresh(); }); });
  $$("[data-close-cart]").forEach(function (b) { b.addEventListener("click", function () { open(false); }); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") open(false); });
  $$("[data-checkout]").forEach(function (b) {
    b.addEventListener("click", function () { location.href = urls.checkout; });
  });

  function render(cart) {
    $$("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
    var total = document.querySelector("[data-cart-total]");
    if (total) total.textContent = money(cart.total_price);
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<li class="empty">' + esc(strings.empty || "Nothing here yet.") + "</li>";
      return;
    }
    var images = cfg.cartImages || {};
    list.innerHTML = cart.items.map(function (l) {
      var img = l.image || images[l.handle] || "";
      var pack = l.product_has_only_default_variant ? "" : (l.variant_title || "");
      return '<li><img src="' + esc(img) + '" alt=""><div><div class="name">' + esc(l.product_title) + '</div><div class="mono">' +
        esc(pack) + (pack ? " · " : "") + esc(money(l.final_price)) + '</div></div><div class="qty"><button type="button" data-key="' + esc(l.key) +
        '" data-qty="' + (l.quantity - 1) + '" aria-label="' + esc(strings.removeOne || "Remove one") + '">−</button>' + l.quantity +
        '<button type="button" data-key="' + esc(l.key) + '" data-qty="' + (l.quantity + 1) + '" aria-label="' + esc(strings.addOne || "Add one") + '">+</button></div></li>';
    }).join("");
  }
  function refresh() { return request(urls.cart).then(render).catch(function () {}); }
  if (list) {
    list.addEventListener("click", function (e) {
      var t = e.target.closest ? e.target.closest("[data-key]") : null;
      if (!t) return;
      t.disabled = true;
      request(urls.change, { id: t.getAttribute("data-key"), quantity: +t.getAttribute("data-qty") })
        .then(render)
        .catch(function () { refresh(); });
    });
  }
  // Back/forward cache can show a stale count
  window.addEventListener("pageshow", function (e) { if (e.persisted) refresh(); });

  // Menu
  var menuEl = document.querySelector("[data-menu]");
  var menuScrim = document.querySelector(".menu-scrim");
  function openMenu(v) {
    if (!menuEl) return;
    menuEl.hidden = !v; menuScrim.hidden = !v; document.body.classList.toggle("menu-open", v);
  }
  $$("[data-open-menu]").forEach(function (b) { b.addEventListener("click", function () { openMenu(true); }); });
  $$("[data-close-menu]").forEach(function (b) { b.addEventListener("click", function () { openMenu(false); }); });
  if (menuEl) $$("a", menuEl).forEach(function (a) { a.addEventListener("click", function () { openMenu(false); }); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") openMenu(false); });

  // Background videos: wide crop on desktop, tall crop on phones, posters only for reduced motion.
  // The hero starts straight away; the others load when they scroll near the screen.
  var tall = window.matchMedia("(max-width: 640px)").matches;
  var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function startVideo(v) {
    if (v.dataset.started) return;
    v.dataset.started = "1";
    var src = tall ? v.dataset.tall : v.dataset.wide;
    if (!v.canPlayType('video/mp4; codecs="avc1.640028"')) src = (tall ? v.dataset.tallWebm : v.dataset.wideWebm) || src;
    v.src = src;
    var p = v.play && v.play();
    if (p && p.catch) p.catch(function () {});
  }
  var bgVideos = $$("video[data-wide]");
  bgVideos.forEach(function (v) { v.poster = tall ? v.dataset.posterTall : v.dataset.posterWide; });
  if (!still) {
    var io = "IntersectionObserver" in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { startVideo(e.target); io.unobserve(e.target); } });
    }, { rootMargin: "300px" }) : null;
    bgVideos.forEach(function (v) {
      if (v.hasAttribute("data-hero-video") || !io) startVideo(v); else io.observe(v);
    });
  }

  // Tap a can, hear it crack. Card links wait a beat so the sound plays before the page changes.
  var crack = null;
  function playCrack() {
    try {
      if (!crack) crack = new Audio(cfg.crackSound);
      crack.currentTime = 0;
      var p = crack.play();
      if (p && p.catch) p.catch(function () {});
    } catch (e) {}
  }
  $$(".product-media, .pdp-media").forEach(function (el) {
    el.addEventListener("click", function (e) {
      if (!cfg.crackSound) return;
      playCrack();
      var href = el.getAttribute("href");
      if (href && href.charAt(0) !== "#" && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        setTimeout(function () { location.href = href; }, 450);
      }
    });
  });

  // Nutrition flavour tabs
  $$("[data-nut-tab]").forEach(function (t) {
    t.addEventListener("click", function () {
      $$("[data-nut-tab]").forEach(function (o) { o.setAttribute("aria-selected", o === t ? "true" : "false"); });
      $$("[data-nut]").forEach(function (p) { p.hidden = p.dataset.nut !== t.dataset.nutTab; });
    });
  });
})();
